import { TICKET_INPUT_CHANNELS } from 'gcs-common/slices/tickets/ticketsConstants';
import type { Schema } from 'gcs-common/types/typeHelper';
import Select from 'react-select';
import type { Entries } from 'type-fest';

interface OptionType {
  value: Schema<'EtsInputChannelEnum'>;
  label: string;
}

const inputChannelOptions: OptionType[] = (
  Object.entries(TICKET_INPUT_CHANNELS) as Entries<typeof TICKET_INPUT_CHANNELS>
)
  .filter(([, value]) => !value.hidden)
  .map(([key, value]) => ({
    value: key,
    label: value.label,
  }));

interface TicketInputChannelSelectProps {
  onChange: (value: Schema<'EtsInputChannelEnum'> | undefined) => void;
}

const TicketInputChannelSelect = ({ onChange }: TicketInputChannelSelectProps) => {
  return (
    <Select<OptionType>
      name="erpCustomerId"
      options={inputChannelOptions}
      onChange={(selectedOption) => {
        onChange(selectedOption?.value);
      }}
      placeholder="Eingangskanal auswählen"
    />
  );
};

export default TicketInputChannelSelect;
